import React, { useEffect, useState } from "react";
import styled from "styled-components";
import OrderProgress from "./OrderProgress/index";
import { UserTypes } from "../../constants/OrderPayout/utils";
import { isValNull, getPath, isEmpty } from "../../utils";
import * as LifeLineAction from "../../store/actions/LifeLine";
import * as UserActions from "../../store/actions/User";
import { bindActionCreators } from "redux";
import LifelineApi from "../../services/api/Lifeline";
import { connect } from "react-redux";
import {
  InfoLine,
  Delivery,
  MailFill,
  Call,
  Location,
  ProfileUser,
  CallLine,
} from "sushiweb/Icons";
import CallLogsModal from "./OrderInfo/CallLogsModal";
import SupportActions from "./SupportActions";
import OrderInfo from "./OrderInfo";
import ActionHistoryModal from "./OrderInfo/ActionHistoryModal";
import SupportTags from "./OrderInfo/SupportTags";
import PriceBreakup from "./PriceBreakup/PriceBreakup";

const GetDetailIcon = (type) => {
  const color = "rgb(39, 129, 231)";

  switch (type) {
    case "name":
      return <ProfileUser color={color} />;
    case "fe_id":
      return <Delivery color={color} />;
    case "email":
      return <MailFill color={color} />;
    case "address":
      return <Location color={color} />;
    case "phone":
      return <Call color={color} />;
    default:
      return <InfoLine color={color} />;
  }
};

const LifeLineOrderDetailCard = (props) => {
  const { data, setStatus } = props;
  const [modalContent, setModalContent] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [priceDetails, setPriceDetails] = useState({});
  const orderDate = new Date(data.created_at).toLocaleString();
  let orderInTerminalState = false;
  if (data.order_status === "COMPLETE" || data.order_status == "CANCEL") {
    orderInTerminalState = true;
  }

  const orderItems = getPath(data, "order_items", []);
  const actionHistory = getPath(data, "action_history", []);

  const handleCallIconClick = (type, phoneNumber, id) => {
    props
      .connectOutgoingCall(type, phoneNumber, data.external_order_id, id)
      .then((res) => {
        if (res && getPath(res, "message", "").length != 0) {
          setStatus({
            type: "success",
            message: getPath(res, "message", "Call initiated successfully!"),
          });
        } else {
          setStatus({
            type: "error",
            message: "Error while initiating call!",
          });
        }
      });
  };

  const handleAddressIconClick = (googleMapLink) => {
    window.open(googleMapLink, "_blank");
  };

  const handleDoClick = () => {
    props.getCallLogs(data.external_order_id).then((res) => {
      if (res) {
        setModalContent(res);
        setShowModal(true);
      } else {
        setStatus({
          type: "error",
          message: "Error while retrieving call logs",
        });
      }
    });
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const getGoogleMapLinkForSourceAndDest = (source, dest) => {
    return `https://www.google.com/maps/dir/?api=1&origin=${source.latitude},${source.longitude}&destination=${dest.latitude},${dest.longitude}`;
  };

  const getCustomTags = (props) => {
    const { isXtremeOrder, isBatchedOrder, otpDetails } = props;
    if (!isXtremeOrder) {
      return [];
    }
    let customTags = [];
    if (isBatchedOrder) {
      customTags.push("BATCHED");
    }
    if (!isValNull(otpDetails)) {
      Object.entries(otpDetails).forEach(([key, value]) => {
        if (!isEmpty(value)) {
          customTags.push(key);
        }
      });
    }
    return customTags;
  };

  const UserDetailCard = (props) => {
    const { userData, type, googleMapLink, label } = props;

    if (isValNull(userData)) {
      return null;
    }
    return (
      <UserDetailStyle>
        <UserDetailWrapper>
          {Object.keys(userData).map((key) => {
            const value = userData[key];
            if (key === "id") {
              let userDetailHeading = (label || type) + " #" + userData[key];
              if (type === UserTypes.Merchant && !isValNull(data.source_name)) {
                let sourceName = "(" + data.source_name + ")";
                return (
                  <div
                    style={{
                      display: "flex",
                      marginBottom: "10px",
                      alignItems: "center",
                    }}
                  >
                    <p
                      style={{
                        marginRight: "5px",
                        color: "#828282",
                      }}
                    >
                      {userDetailHeading}
                    </p>
                    <b>{sourceName}</b>
                  </div>
                );
              }
              return (
                <p style={{ marginBottom: "10px", color: "#828282" }}>
                  {userDetailHeading}
                </p>
              );
            } else if (key === "address_details") {
              return (
                <div>
                  <UserDetailContentWrapper>
                    <IconStyle
                      onClick={() => handleAddressIconClick(googleMapLink)}
                      style={{ cursor: "pointer" }}
                    >
                      {GetDetailIcon("address")}
                    </IconStyle>
                    <p>{value.address}</p>
                  </UserDetailContentWrapper>
                </div>
              );
            } else if (key === "phone") {
              return (
                <UserDetailContentWrapper>
                  <IconStyle
                    onClick={() =>
                      handleCallIconClick(type, value, userData["id"])
                    }
                    style={{ cursor: "pointer" }}
                  >
                    {GetDetailIcon(key)}
                  </IconStyle>
                  <p>{value}</p>
                </UserDetailContentWrapper>
              );
            }

            return (
              <UserDetailContentWrapper>
                <IconStyle>{GetDetailIcon(key)}</IconStyle>
                <p>{value}</p>
              </UserDetailContentWrapper>
            );
          })}
        </UserDetailWrapper>
      </UserDetailStyle>
    );
  };

  return [
    <LifeLineOrderDetailCardContainer>
      <LifeLineOrderDetailCardHeader>
        <p>Order ID: {data.external_order_id}</p>
        <p>Status: {data.order_status}</p>
        <p>
          {data.source}, {data.category} | ₹{data.total_amount},{" "}
          {data.payment_mode}
        </p>
        <p>{orderDate}</p>
        {!orderInTerminalState && <SupportActions orderId={data.id} />}
      </LifeLineOrderDetailCardHeader>

      <UserDetailContainer>
        <UserDetailCard
          userData={data.customer}
          type={UserTypes.Consumer}
          googleMapLink={getGoogleMapLinkForSourceAndDest(
            data.customer.address_details,
            data.merchant.address_details
          )}
        />
        <UserDetailCard userData={data.driver} type={UserTypes.Driver} />
        <UserDetailCard
          userData={data.merchant}
          type={UserTypes.Merchant}
          googleMapLink={getGoogleMapLinkForSourceAndDest(
            data.customer.address_details,
            data.merchant.address_details
          )}
        />
        <UserDetailCard
          userData={data.registered_user}
          type={"Merchant"}
          label={"Registered User"}
        />
        <AdditionalInfoDiv>
          <SupportTags
            orderID={data.id}
            tagIDs={data.support_tag_ids}
            customTags={getCustomTags({
              isXtremeOrder: data.xtreme_order,
              isBatchedOrder: data.is_batched_order,
              otpDetails: getPath(data, "timeline_details.otp_details", null),
            })}
          ></SupportTags>
          <CallLogStyle onClick={handleDoClick}>
            <CallLine size="1rem" />
            <b> Call Logs </b>
          </CallLogStyle>
          {!isEmpty(orderItems) && <OrderInfo data={orderItems}></OrderInfo>}
          {!isEmpty(actionHistory) && (
            <ActionHistoryModal data={actionHistory}></ActionHistoryModal>
          )}
        </AdditionalInfoDiv>
      </UserDetailContainer>
      {(data.delivery_instructions || priceDetails) && (
        <OrderInfoContainer>
          <InstructionContainer>
            <InstructionHeading>Instructions:</InstructionHeading>
            {Object.entries(
              data.delivery_instructions || {
                drop: "NA",
              }
            )?.map(([key, value]) => {
              return (
                <Instruction>
                  <span>{key}:</span> {value}
                </Instruction>
              );
            })}
          </InstructionContainer>
          {data.xtreme_order && priceDetails && (
            <PriceBreakup
              orderId={data.external_order_id}
              setStatus={setStatus}
            />
          )}
        </OrderInfoContainer>
      )}

      <OrderProgress
        details={data.timeline_details}
        orderId={data.external_order_id}
        trackingLink={data.tracking_link}
      />
    </LifeLineOrderDetailCardContainer>,
    <CallLogsModal
      showModal={showModal}
      handleClose={handleClose}
      modalContent={modalContent}
    />,
  ];
};

const OrderInfoContainer = styled.div`
  display: flex;
  padding: 20px;
  border: 0.5px solid #cfcfcf;
  border-radius: 10px;
  margin-bottom: 15px;
  gap: 50px;
  justify-content: space-between;
`;

const InstructionContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const InstructionHeading = styled.div`
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 10px;
`;

const Instruction = styled.div`
  display: flex;
  gap: 10px;
  max-width: 400px;
  margin-bottom: 4px;

  span {
    font-weight: bold;
    color: #828282;

    &:first-letter {
      text-transform: capitalize;
    }
  }
`;

const AdditionalInfoDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 300px;
`;

const IconStyle = styled.div`
  margin-right: 5px;
`;

const CallLogStyle = styled.div`
  display: flex;
  cursor: pointer;
  b {
    padding-left: 2px;
  }
`;

const LifeLineOrderDetailCardContainer = styled.section`
  border: 0.5px solid #cfcfcf;
  padding: 10px;
  border-radius: 10px;
  margin-bottom: 20px;
`;

const LifeLineOrderDetailCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 0.5px solid #cfcfcf;
  padding: 0.5rem;
`;

const UserDetailContainer = styled.div`
  display: flex;
  padding: 40px 20px;
  flex-wrap: wrap;
  gap: 60px 20px;
`;

const UserDetailContentWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  p {
    word-break: break-word;
  }
`;

const UserDetailWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

const UserDetailStyle = styled.div`
  width: 300px;
  display: flex;
  justify-content: center;
`;

const mapDispatchToProps = (dispatch) => ({
  getCallLogs: bindActionCreators(LifeLineAction.getLifelineCallLogs, dispatch),
  setStatus: bindActionCreators(UserActions.setStatus, dispatch),
  connectOutgoingCall: bindActionCreators(
    LifeLineAction.ConnectOutgoingCall,
    dispatch
  ),
});

export default connect(null, mapDispatchToProps)(LifeLineOrderDetailCard);
